import React, { useState, useEffect, useRef } from "react";
import "../../../assets/scss/components/templates/customSelect.scss";
import searchIcon from "../../../assets/images/library/select-serch-icon.svg";
import { Image } from "react-bootstrap";
import industry from "../../../assets/images/library/industry.svg";
import selectedOptionIcon from "../../../assets/images/library/selected-option.svg";

import dropdownArrow from "../../../assets/images/library/dropdown-arrow.svg";
import check from "../../../assets/images/resume/check.svg";
const IndustrySelect = ({
  options,
  defaultOption,
  onSelect,
  disabled,
  skillOptions,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [industries, setIndustries] = useState(options);
  const [selectedOption, setSelectedOption] = useState(defaultOption);
  const selectRef = useRef(null);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setIndustries(
      options.filter((option) =>
        option.toLowerCase().includes(e.target.value.toLowerCase())
      )
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (option) => {
    setSelectedOption(option);
    onSelect(option);
    setIsOpen(false);
  };

  return (
    <div
      className={`custom-select industry-select ${disabled ? "disabled" : ""}`}
      ref={selectRef}
    >
      <img className="select-arrow-icon" src={dropdownArrow} alt="dropdown" />
      <div
        className="selected-option"
        onClick={() => !disabled && setIsOpen(!isOpen)}
      >
        <Image src={industry} className="me-2" /> Industry:
        <span className="ms-1">
          {selectedOption}
          {/* {selectedOptions.length > 1
            ? selectedOptions.length + " Selected"
            : selectedOptions.join(", ")} */}
        </span>
      </div>
      {/* {isOpen && (
        <ul className={`options-list`}>
          <div className="search-field">
            <input
              type="text"
              className="search-input"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleSearchChange}
            />
            <span className="search-icon">
              <Image src={searchIcon} />
            </span>
          </div>
          {options
            .filter((option) =>
              option.toLowerCase().includes(searchTerm.toLowerCase())
            )
            .map((option, index) => (
              <li key={index} className={`option-item`}>
                <div className="checkbox">
                  <div className="custom-checkbox-container">
                    <input
                      type="checkbox"
                      id={`customCheckbox-${index}`}
                      checked={selectedOptions.includes(option)}
                      onChange={() => handleSelect(option)}
                      className="hidden-checkbox"
                      disabled={disabled}
                    />
                    <label
                      htmlFor={`customCheckbox-${index}`}
                      className={`custom-checkbox ${
                        selectedOptions.includes(option) ? "checked" : ""
                      }`}
                    >
                      {selectedOptions.includes(option) && (
                        <span className="checkmark">
                          <Image src={check} />
                        </span>
                      )}
                    </label>
                  </div>
                  <label
                    htmlFor={`customCheckbox-${index}`}
                    className="paragraph-main-regular text-start remember-text"
                  >
                    {option}
                  </label>
                </div>
              </li>
            ))}
        </ul>
      )} */}
      {isOpen && (
        <ul className={`options-list`}>
          <div className="search-field">
            <input
              type="text"
              className="search-input"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleSearchChange}
            />
            <span className="search-icon">
              <Image src={searchIcon} />
            </span>
          </div>
          {industries.map((option, index) => (
            <div className={`${skillOptions}`}>
              <li
                key={index}
                className={`option-item ${
                  selectedOption === option ? "selected" : ""
                }`}
                onClick={() => handleSelect(option)}
              >
                {option}
                {selectedOption === option ? (
                  <Image src={selectedOptionIcon} />
                ) : (
                  ""
                )}
              </li>
            </div>
          ))}
        </ul>
      )}
    </div>
  );
};

export default IndustrySelect;
